import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RequestStatus } from 'shared/constants/State';
import * as legacyRecords from 'state/records/types';

const name = 'medicalRecords/saveCurrentRecord';

export interface SaveRequestState {
  status: RequestStatus;
  error: string;
}

export const initialState: SaveRequestState = {
  status: RequestStatus.Ready,
  error: '',
};

export const pendingState = { status: RequestStatus.Pending, error: '' };
export const successState = { status: RequestStatus.Success, error: '' };

const saveCurrentRecordSlice = createSlice({
  name,
  initialState,
  reducers: {
    ready: () => {
      return initialState;
    },
    pending: () => pendingState,
    success: () => successState,
    error: (_state, action: PayloadAction<string>) => {
      return { status: RequestStatus.Error, error: action.payload };
    },
  },
  extraReducers: {
    [legacyRecords.INITIALIZED]: () => initialState,
  },
});

export const {
  ready,
  pending,
  success,
  error,
} = saveCurrentRecordSlice.actions;

export default saveCurrentRecordSlice.reducer;
